<template>
  <v-container fluid>
    <v-layout row wrap align-center class="pb-15">
      <v-row>
        <v-parallax :src="require('@/assets/cover.jpg')" height="380">
          <v-layout column justify-center>
            <div class="headline white--text mb-3 text-center">Gritus - Retail Made Smart</div>
            <div
              class="white--text mb-3 text-center"
            >In Gritus, we are striving to bring digital detail to life with our smart consoles, so we help transform retail & bring value to the society in this digital experience era. Through our interactive console experience, with our use of data & innovation, Gritus is enhancing shopper experience & retail merchandising to help enable Hong Kong’s Smart City lifestyle.</div>
          </v-layout>
        </v-parallax>
      </v-row>
    </v-layout>

    <v-layout wrap justify-center>
      <v-col cols="12" md="6" class="pt-0">
        <v-col cols="12" class="pt-0">
          <account-overview></account-overview>
        </v-col>
        <v-col cols="12" class="pt-0">
          <account-withdrawal></account-withdrawal>
        </v-col>
        <v-col cols="12" class="pt-0">
          <v-card class="pa-3">
            <v-card-title class="justify-center">
              <h3 class="headline">{{ $t('info.vision') }}</h3>
            </v-card-title>
            <v-card-text>
              Our Gritus consoles are designed by us with Gritus’ own design patent,
              produced in carefully selected factory & QCed by our expert staff to make
              sure they last & operate at top quality. With that, we also have the best maintenance
              & support naturally to ensure operation sustainability as well as product longevity.
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" class="pt-0">
          <v-card class="transparent pa-3">
            <v-card-title primary-title class="justify-center">
              <div class="headline">{{ $t('info.contact_us') }}</div>
            </v-card-title>
            <v-list class="transparent">
              <v-list-item>
                <v-list-item-action>
                  <v-icon class="blue--text text--lighten-2">message</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{ $t('info.chatbox') }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-action>
                  <v-icon class="blue--text text--lighten-2">place</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{ $t('info.gritus_address') }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-action>
                  <v-icon class="blue--text text--lighten-2">email</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>franchise_cs@gritus.com</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
      </v-col>
      <v-col cols="12" md="6" class="pt-0">
        <location-change-request></location-change-request>
      </v-col>
    </v-layout>
  </v-container>
</template>

<script>
// Components
import AccountOverview from '@/components/AccountOverview'
import AccountWithdrawal from '@/components/AccountWithdrawal'
import LocationChangeRequest from '@/components/LocationChangeRequest'

export default {
  components: {
    AccountOverview,
    AccountWithdrawal,
    LocationChangeRequest
  }
}
</script>
